<template>
  <el-select
    ref="zkSelect"
    v-model="vo"
    clearable
    show-avatar-mode
    :placeholder="placeholder"
    :multiple="multiple"
    :class="b()"
    :select-dropdown-option="{
      minWidth: 210
    }"
  >
    <el-option-group
      v-for="group in groups"
      :key="group.value"
      :label="group.label"
    >
      <el-option
        v-for="option in group.options"
        :key="option.value"
        :label="option.label"
        :value="option.value"
        :avatar="option.avatar || 'zkicon iconuser'"
        :disabled="option.accountEnabled === 0"
      >
        <template #after>
          <span
            v-if="option.projectRole === 'innerCollaborator'"
            :class="b('option-tag')"
          >
            {{ $t('saas.project.innerCollaborator.tag') }}
          </span>
          <span
            v-else-if="option.accountEnabled === 0"
            :class="b('option-tag')"
          >
            {{ $t('org.user.removed') }}
          </span>
        </template>
      </el-option>
    </el-option-group>
    <el-option
      v-for="option in options"
      :key="option.value"
      :label="option.label"
      :value="option.value"
      :avatar="option.avatar || 'zkicon iconuser'"
      :disabled="option.accountEnabled === 0"
    >
      <template #after>
        <span
          v-if="option.projectRole === 'innerCollaborator'"
          :class="b('option-tag')"
        >
          {{ $t('saas.project.innerCollaborator.tag') }}
        </span>
        <span
          v-else-if="option.accountEnabled === 0"
          :class="b('option-tag')"
        >
          {{ $t('org.user.removed') }}
        </span>
      </template>
    </el-option>
  </el-select>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';

export default {
  name: 'TheMemberFileGroupSelect',
  props: {
    value: {
      type: [Array, String, Number],
      default: ''
    },
    groups: {
      type: Array,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      vo: []
    };
  },
  computed: {
    hasVo() {
      if (Array.isArray(this.vo)){
        return !!this.vo.length;
      }
      return !!this.vo;
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.vo = val;
      }
    },
    vo: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    },
    multiple(val) {
      this.switchMultiple(val);
    }
  },
  methods: {
    switchMultiple(val) {
      if (val) {
        this.vo = [];
        this.clearLabel();
        return;
      }
      this.vo = '';
    },
    clearLabel() {
      const { select } = this.$refs.zkSelect?.$refs;
      select.selectedLabel = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@zk/theme/lib/mixins.scss';
@include b(the-member-file-group-select) {
  @include e(member-option) {
    display: flex;
    align-items: center;
    span{
      flex: auto;
    }
    .el-avatar{
      margin-right: 10px;
    }
    &.group-option{
      .el-avatar{ margin-left: 14px; }
    }
  }
  @include e(option-tag) {
    height: 18px;
    display: inline-block;
    padding: 0 4px;
    color: #4c52a8;
    border-radius: 13px;
    background-color: rgba(66,91,120,.1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 18px;
    text-align: center;
    font-weight: 400!important;
    margin-left: 4px;
  }
}
</style>
